(() => {
  'use strict';
  if (customElements.get('pic-context-upsell')) return;
  let busy = false;
  class PicContextUpsell extends HTMLElement {
    connectedCallback() {
      this.onsubmit = (event) => this.add(event);
      this.syncCart();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.syncCart());
      }
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    async syncCart(cart) {
      try {
        cart = cart || await this.read('cart.js');
        if (!this.isConnected) return;
        const cards = [...this.querySelectorAll('[data-upsell-card]')];
        cards.forEach(card => { card.hidden = cart.items.some(item => String(item.product_id) === card.dataset.product); });
        this.hidden = cards.every(card => card.hidden);
      } catch (_) { /* No optimistic cart state; submit performs a fresh preflight. */ }
    }
    async read(path, options = {}) {
      const response = await fetch((this.dataset.root || '/') + path, {credentials: 'same-origin', cache: 'no-store', ...options});
      const data = await response.json();
      if (!response.ok) throw new Error('Bitte prüfen Sie den Warenkorb und versuchen Sie es erneut.');
      return data;
    }
    navigateCart() { location.assign((this.dataset.root || '/') + 'cart'); }
    async add(event) {
      const form = event.target.closest('form');
      if (!form || !this.contains(form)) return;
      event.preventDefault();
      const button = form.querySelector('button');
      if (busy || button.disabled) return;
      busy = true; button.disabled = true;
      const status = form.querySelector('[data-upsell-status]');
      status.textContent = 'Wird hinzugefügt …';
      let attempted = false;
      try {
        const currentCart = await this.read('cart.js');
        if (currentCart.items.some(item => String(item.product_id) === form.dataset.product)) {
          status.textContent = 'Schon im Warenkorb. Sie können die Menge dort ändern.';
          return;
        }
        const product = await this.read('products/' + encodeURIComponent(form.dataset.handle) + '.js');
        const variant = product.variants.find(item => String(item.id) === form.dataset.variant);
        if (String(product.id) !== form.dataset.product || product.vendor.trim().toLowerCase() !== 'pic' || !variant?.available) {
          status.textContent = 'Diese Packung ist aktuell nicht verfügbar. Bitte öffne die Produktseite.';
          return;
        }
        if (variant.price !== Number(form.dataset.price)) {
          status.textContent = 'Der Preis hat sich geändert. Bitte laden Sie die Seite neu, bevor Sie die Packung hinzufügen.';
          return;
        }
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender().map(section => section.id) || [];
        attempted = true;
        const added = await this.read('cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: Number(form.dataset.variant), quantity: 1}], sections, sections_url: location.pathname})});
        const cart = await this.read('cart.js');
        if (!cart.items.some(item => String(item.variant_id) === form.dataset.variant)) throw new Error('Bitte prüfen Sie Ihren Warenkorb.');
        status.textContent = 'Zum Warenkorb hinzugefügt.';
        document.querySelectorAll('pic-context-upsell').forEach(element => element.syncCart(cart));
        if (!document.querySelector('cart-items') && drawer && sections.every(id => added.sections?.[id])) {
          // Return focus to the stable cart link, not to the now-hidden offer.
          drawer.setActiveElement?.(document.getElementById('cart-icon-bubble'));
          drawer.classList.remove('is-empty');
          drawer.renderContents(added);
          const focusTarget = drawer.querySelector('.drawer__close');
          focusTarget?.focus();
          // The baseline skips open() when active; renew the old DOM focus trap explicitly.
          const inner = drawer.querySelector('.drawer__inner');
          if (drawer.classList.contains('active') && inner && typeof trapFocus === 'function') trapFocus(inner, focusTarget || inner);
        } else this.navigateCart();
      } catch (_) {
        status.textContent = attempted
          ? 'Hinzufügen nicht bestätigt. Bitte prüfen Sie Ihren Warenkorb, bevor Sie es erneut versuchen.'
          : 'Der Warenkorb ist gerade nicht erreichbar. Bitte versuchen Sie es erneut.';
        const link = document.createElement('a');
        link.href = (this.dataset.root || '/') + 'cart';
        link.textContent = ' Warenkorb prüfen';
        status.append(link);
        // A lost POST response may already have added the pack: never retry blindly.
        button.disabled = attempted;
      }
      finally { busy = false; }
    }
  }
  customElements.define('pic-context-upsell', PicContextUpsell);
})();
